import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'rebass/styled-components';
import Icon from '../../../../assets/icon-google-small.svg';

export const GoogleIcon = ({ width, height, ...props }) => (
  <Image src={Icon} alt="Google" width={width} height={height} {...props} />
);

GoogleIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

GoogleIcon.defaultProps = {
  width: '24px',
  height: '24px',
};
